import React from 'react';
import { inject, observer } from 'mobx-react';
import {
  Icon, Comment, Tooltip, Pagination
} from 'antd';
import { isEmpty } from 'lodash';

@observer
class App extends React.Component {

  static defaultProps = {
    prefixCls: "workflow-commit-list",
  }
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      visibleAll: false,
    }
  }

  componentDidMount() {
    const box = this.refs.commentBox;
    if(box && box.clientHeight > 42) {
      this.setState({visible: true});
    }
  }

  simpleCommit = item => {
    const { prefixCls } = this.props;
    return (
      <Comment
        author={item.userName}
        avatar={item.avatar}
        datetime={item.createDate}
        className={`${prefixCls}-item`}
        key={item.id}
      >
        <div className={`${prefixCls}-item-content`}>
          {item.content}
        </div>
      </Comment>
    )
  }

  onClick = (item) => {
    const { onClick } = this.props;
    typeof onClick === 'function' && onClick(item)
  }

  newCommit = item => {
    const { prefixCls } = this.props;
    return (
      <div className={`${prefixCls}-new`} key={item.id}>
        <div className={`${prefixCls}-new-title`} onClick={() => this.onClick(item)}>{`【${item.demoTitle || '未知表单'}】`}</div>
        <Comment
          author={item.userName}
          avatar={item.avatar}
          datetime={item.createDate}
          className={`${prefixCls}-new-comment`}
          key={item.id}
        >
          <div className={`${prefixCls}-new-comment-content`}>
            {item.content}
          </div>
        </Comment>
      </div>
    )
  }

  render() {
    const { className, datas, prefixCls, page = {}, userNew = false } = this.props;
    const commit = userNew ? this.newCommit : this.simpleCommit;
    return (
      <div className={`${prefixCls} ${className}`}>
        {
          datas.length > 0 ? datas.map(item => commit(item))
          : <div className={`${prefixCls}-empty`}>
              <svg className={`icon-font ${prefixCls}-empty-icon`} aria-hidden="true">
                <use href="#icon-pinglun"></use>
              </svg>
              <span>暂无评论</span>
            </div>
        }
        {
          !isEmpty(page) ?
            <Pagination 
              hideOnSinglePage
              current={page.pageNum}
              pageSize={page.pageSize}
              total={page.count}
              size='small'
              onChange={page.onChange}
              // simple
              className={`${prefixCls}-pagination`}
            /> : null
        }
      </div>
    );
  }
}
export default App;


// WEBPACK FOOTER //
// ./src/components/workflow/Comments.js